import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { Feature } from './ui/feature-section-with-bento-grid';

const TrustSection = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.12 });

  return (
    <section id="trust-layer" className="relative py-20 sm:py-24 lg:py-32 bg-[--bg-primary]">
      <div className="absolute top-0 left-0 right-0 section-divider" />

      <div ref={sectionRef} className="max-w-[1500px] mx-auto px-4 sm:px-6">
        <div
          className={`mb-14 max-w-4xl transition-all duration-700 ease-out ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
          }`}
        >
          <p className="section-eyebrow mb-4">Why Synentia</p>
          <h2 className="text-[clamp(2rem,4.1vw,3.8rem)] font-semibold text-[--text-primary] leading-[1.02]">
            Domain depth first.
            <br />
            <span className="accent-wash">AI second.</span>
          </h2>
          <p className="mt-6 text-lg text-[--text-secondary] max-w-3xl">
            Most AI companies learn your industry on your budget. We come in already knowing the operational patterns, the failure points, and where the value is — because we've built and run these systems ourselves. Domain expertise isn't a selling point. It's the reason our systems work.
          </p>
        </div>

        <div
          className={`transition-all duration-700 ease-out delay-150 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <Feature />
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
